import { AmazonS3ConnectionProvider } from "@via/context/amazon-s3-connection-context.tsx";
import { DataSourceProvider } from "@via/context/data-source-context.tsx";
import { GoogleCloudConnectionProvider } from "@via/context/google-cloud-connection-context.tsx";
import { SshDataConnectionProvider } from "@via/context/ssh-data-connection-context.tsx";
import { UrlDataConnectionProvider } from "@via/context/url-data-connection-context.tsx";
import { BaseSpaceConnectionProvider } from "@via/context/basespace-connection-context.tsx";
import React, { ReactNode } from "react";

interface CloudConnectionProviderProps {
  children: ReactNode;
}

const CloudConnectionProvider: React.FC<CloudConnectionProviderProps> = ({
  children,
}) => {
  return (
    <DataSourceProvider>
      <GoogleCloudConnectionProvider>
        <AmazonS3ConnectionProvider>
          <SshDataConnectionProvider>
            <UrlDataConnectionProvider>
              <BaseSpaceConnectionProvider>
                {children}
              </BaseSpaceConnectionProvider>
            </UrlDataConnectionProvider>
          </SshDataConnectionProvider>
        </AmazonS3ConnectionProvider>
      </GoogleCloudConnectionProvider>
    </DataSourceProvider>
  );
};

export default CloudConnectionProvider;
